export default "__VITE_ASSET__jt7QydZ6__"